<template>
    <RouterLink
        v-if="buttonLink"
        :to="buttonLink"
        class="product-box product-box--quarter"
        :class="{ 'is-link': buttonLink, 'product-box--quarter': isQuarter }"
    >
        <div class="is-centered">
            <figure class="product-box__image image is-square">
                <LazyLoadedImage
                    :src="imgSrc"
                    alt="Produktbild"
                ></LazyLoadedImage>
            </figure>
            <div class="product-box__content pt-3 hyphenate">
                <div
                    class="title is-uppercase is-size-5-mobile has-text-grey-dark"
                    v-if="title"
                >
                    {{ title }}
                </div>
                <div class="content rich-text hyphenate">
                    <div
                        v-if="subheader"
                        class="title is-4 mb-2"
                        :class="headerStyle"
                    >
                        {{ subheader }}
                    </div>
                    <div v-html="text" class="hyphenate" />
                </div>
                <div class="content" v-if="buttonLink">
                    <RouterLink
                        :to="buttonLink"
                        class="link link-primary product-box__link"
                    >
                        Mehr erfahren
                        <SvgIcon
                            icon="icon--directional_arrow-right"
                            class="is-primary-dark"
                            :grow-by-height="false"
                        />
                    </RouterLink>
                </div>
            </div>
        </div>
    </RouterLink>
    <div v-else class="product-box">
        <div class="is-centered" v-if="imgSrc">
            <figure class="product-box__image image is-square">
                <LazyLoadedImage
                    :src="imgSrc"
                    alt="Produktbild"
                ></LazyLoadedImage>
            </figure>
            <div class="product-box__content pt-3 hyphenate">
                <div
                    class="title is-uppercase is-size-5-mobile has-text-grey-dark"
                    v-if="title"
                >
                    {{ title }}
                </div>
                <div class="content rich-text hyphenate">
                    <div
                        v-if="subheader"
                        class="title is-4 mb-2"
                        :class="headerStyle"
                    >
                        {{ subheader }}
                    </div>
                    <div v-html="text" class="hyphenate" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LazyLoadedImage from '../shared/LazyLoadedImage';
import SvgIcon from '../svg/SvgIcon';

export default {
    name: 'ProductBoxElement',
    components: { LazyLoadedImage, SvgIcon },
    data() {
        return {};
    },
    props: {
        contentData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isQuarter() {
            return this.contentData.appearance.layout === 'testtestestest';
        },
        imgSrc() {
            if (this.contentData.content.gallery.rows[1]) {
                return this.contentData.content.gallery.rows[1].columns[1]
                    .publicUrl;
            }
            return null;
        },
        title() {
            return this.contentData.content.header;
        },
        subheader() {
            return this.contentData.content.subheader;
        },
        text() {
            let bodytext = this.contentData.content.bodytext;
            bodytext = bodytext.replace(/(?:\r\n|\r|\n)/g, '<br>');
            return bodytext.replace(
                /\/fileadmin/g,
                'https://content.murtfeldt-as.de/fileadmin'
            );
        },
        buttonLink() {
            return this.contentData.content.headerLink.url;
        },
        headerStyle() {
            let position;
            let color;

            switch (this.contentData.content.headerPosition) {
                case 'right':
                    position = 'has-text-right';
                    break;
                case 'center':
                    position = 'has-text-centered';
                    break;
                default:
                    position = 'has-text-left';
            }

            switch (this.contentData.content.headerLayout) {
                case 0:
                    color = 'has-text-grey';
                    break;
                case 1:
                    color = 'has-text-grey-dark';
                    break;
                case 2:
                    color = 'has-text-primary-dark';
            }
            return [color, position];
        },
    },
};
</script>

<style lang="scss">
.product-box {
    width: auto;
    max-width: 400px;
    color: $text;
    cursor: default;
    margin-bottom: 2rem;

    &__image {
        transition: all 100ms $easing;
    }

    &__content {
        padding: 0 1rem;
    }

    &.is-link {
        .product-box__link {
            display: inline-block;
            color: $primary-dark;
            transition: all $speed $easing;

            &:hover {
                transform: translateX(10px);
                transition: all 170ms $easing;
                color: $primary-dark;
            }
        }

        &:hover {
            cursor: pointer;
            color: $text-light;

            .product-box__image {
                /*box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);*/
                box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
                    0 6px 6px rgba(0, 0, 0, 0.23);
                transform: translateY(-5px);

                transition: all 170ms $easing;
            }
        }
    }
}

.cms-view-content {
    @media screen and (min-width: 576px) {
        .cms-view__element.product-box {
            width: percentage(math.div(1, 4));
            max-width: none;
            margin: 1rem;
            .product-box {
                max-width: none;
            }

            .product-box__content {
                padding: 0;
            }
        }
        .cms-view__element.product-box.product-box--quarter {
            //       width: percentage(1/6);
            width: 17.6%;
        }
    }
    @media screen and (min-width: 576px) and (max-width: $widescreen) {
        .cms-view__element.product-box.product-box--quarter {
            width: percentage(math.div(1, 3));
        }
    }

    @media screen and (min-width: $tablet) {
        .cms-view__element.product-box {
            margin: 1.5rem;
        }
    }

    @media screen and (min-width: $fullhd) {
        .cms-view__element.product-box {
            margin: 2.5rem;
        }
    }
}
</style>
